import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { VehicleFilter } from '@app-services/open.service';
import { FilterDetailItem } from '../../exchange-filter/exchange-filter.model';
import { ExchangeFilterService } from '../../exchange-filter/exchange-filter.service';

@Component({
  selector: 'app-filter-details',
  templateUrl: './filter-details.component.html',
  styleUrls: ['./filter-details.component.scss'],
})
export class FilterDetailsComponent implements OnInit, OnChanges {
  private readonly exchangeFilterService = inject(ExchangeFilterService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input()
  filter: VehicleFilter;

  @Input()
  displayMode: 'inline' | 'chips' = 'inline';

  @Input()
  hideOemDealerType = false;

  @Input()
  oemDealerNames: Record<string, string> = {};

  @Input()
  equipmentNames: Record<string, string> = {};

  filterItems: FilterDetailItem[] = [];

  ngOnInit(): void {
    this.refreshFilterItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['filter'] && !changes['filter'].firstChange) ||
      changes['oemDealerNames'] ||
      changes['equipmentNames'] ||
      changes['hideOemDealerType']
    ) {
      this.refreshFilterItems();
    }
  }

  refreshFilterItems(): void {
    this.exchangeFilterService
      .resolveFilterDetailItems(
        this.filter,
        {
          oemDealerNames: this.oemDealerNames,
          equipmentNames: this.equipmentNames,
        },
        {
          hideOemDealerType: this.hideOemDealerType,
        },
      )
      .subscribe((items) => {
        this.filterItems = items;
        this.cdr.markForCheck();
      });
  }
}
